import React from "react";
import SearchIcon from "@/assets/icons/SearchIcon.svg";
import EmailIcon from "@/assets/icons/MailIconBg.svg";

export type InputFieldProps = {
  defaultValue?: string | number;
  name: string;
  label?: string;
  placeholder?: string;
  type?: "text" | "email" | "password" | "search" | "number";
  variant?: "default" | "search" | "iconEmail";
  className?: string;
  value?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  disabled?: boolean;
  onKeyDown?: any;
  max?:number
  showLink?: boolean;
};

const InputField = React.forwardRef<HTMLInputElement, InputFieldProps>(
  (
    {
      defaultValue,
      name,
      label,
      max,
      onKeyDown,
      placeholder,
      type = "text",
      variant = "default",
      className,
      value = "",
      onChange,
      error,
      disabled = false,
      showLink = false,
    },
    ref
  ) => {
    const isSearch = variant === "search";
    const isIconEmail = variant === "iconEmail";

    const inputBgColor = value
      ? "bg-[#F2F4F7] font-medium"
      : "bg-white font-normal";

    return (
      <div className={`${className} relative w-full`}>
        {label && (
          <label
            htmlFor={name}
            className="block pb-2.5 text-sm font-medium text-gray-700"
          >
            {label}
          </label>
        )}
        <div
          className={`relative w-full border border-[#DCDEE5] rounded-[8px] overflow-hidden flex h-10 ${
            error ? "border-red-500" : ""
          }`}
        >
          {showLink && (
            <div className="bg-[#F8FAFC] flex items-center">
              <p className="text-sm leading-5 tracking-[-0.75%] text-[#9CA3AF] px-4 font-medium">
                http://
              </p>
            </div>
          )}
          <div className="relative flex-1">
            {(isSearch || isIconEmail) && (
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                {isSearch ? <SearchIcon /> : <EmailIcon />}
              </div>
            )}
            <input
              defaultValue={defaultValue}
              ref={ref}
              id={name}
              max={max}
              onKeyDown={onKeyDown}
              name={name}
              type={type}
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              autoComplete={type === "password" ? "current-password" : "off"}
              className={`
                block w-full h-full text-sm placeholder:text-sm text-[#101828] 
                placeholder:text-[#98A2B3] leading-5 tracking-[-1%]
                ${isSearch || isIconEmail ? "pl-10" : "pl-4"} pr-4
                ${inputBgColor}
                focus:bg-white focus:outline-none focus:ring-secondary
                ${error ? "focus:border-red-500" : "focus:border-secondary"}
                ${isSearch || isIconEmail ? "border border-[#E4E7EC]" : ""}
              `}
              disabled={disabled}
            />
          </div>
        </div>
        {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
      </div>
    );
  }
);

InputField.displayName = "InputField";

export default InputField;
